import React, { Component } from "react";

export default class Marker extends Component {
  render() {
    const { place, show, price } = this.props;
    return (
      <div className={`marker ${show ? "show" : ""}`}>
        <div className="box_" id={`marker${place.id}`}>
          <a href={place.url}>{place.title}</a>
          <span className="price" dangerouslySetInnerHTML={{ __html: price }} />
        </div>
        <div className="pin bounce" />
        <div className="pulse" />
      </div>
    );
  }
}
